export default {
  get sentryDsn(): string {
    return process.env.REACT_APP_SENTRY_DSN || "";
  }
};